document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav */
  var navToggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('.site-header__nav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      nav.style.display = nav.classList.contains('is-open') ? 'flex' : '';
    });
  }

  /* Header shadow on scroll */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Reveal on scroll */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Countdown timers */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    var dd = el.querySelector('[data-cd-days]');
    var hh = el.querySelector('[data-cd-hours]');
    var mm = el.querySelector('[data-cd-mins]');
    var ss = el.querySelector('[data-cd-secs]');
    function tick() {
      var diff = Math.max(0, end - Date.now());
      if (dd) dd.textContent = String(Math.floor(diff / 86400000)).padStart(2, '0');
      if (hh) hh.textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
      if (mm) mm.textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      if (ss) ss.textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      if (diff <= 0) clearInterval(timer);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* Fragrance finder */
  var finderForm = document.querySelector('[data-finder-form]');
  if (finderForm) {
    finderForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var gender = finderForm.querySelector('[name="gender"]').value;
      var notes = finderForm.querySelector('[name="notes"]').value;
      var result = finderForm.querySelector('[data-finder-result]');
      var collectionUrl = '/collections/all?filter.p.tag=' + encodeURIComponent(notes);
      if (result) {
        result.innerHTML = 'Great choice — browsing ' + gender + ' fragrances with ' + notes +
          ' notes. <a href="' + collectionUrl + '" style="color:#E4CFA2;text-decoration:underline;">View matches &rarr;</a>';
      }
    });
  }

  /* Product gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.getAttribute('data-full') || thumb.src;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* Quantity stepper */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* Accordions */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    acc.querySelectorAll('.pdp-acc__head').forEach(function (head) {
      head.addEventListener('click', function () {
        head.parentElement.classList.toggle('open');
      });
    });
  });

  /* ---------- Product variant selection ---------- */
  var variantJsonEl = document.querySelector('[data-product-json]');
  if (variantJsonEl) {
    var variants = [];
    try { variants = JSON.parse(variantJsonEl.textContent); } catch (e) { variants = []; }

    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-option-group]'));
    var selected = groups.map(function (group) {
      var active = group.querySelector('.pdp-variant.active') || group.querySelector('.pdp-variant');
      return active ? active.getAttribute('data-option-value') : null;
    });

    var formatMoney = function (cents) {
      var priceEl = document.querySelector('[data-price]');
      var sample = priceEl ? priceEl.textContent.trim() : '';
      var currency = sample.replace(/[\d.,\s]/g, '') || '';
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return currency ? currency + ' ' + amount : amount;
    };

    var apply = function () {
      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return !val || v.options[i] === val; });
      });
      if (!match) return;

      document.querySelectorAll('[data-variant-input]').forEach(function (input) { input.value = match.id; });
      document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = formatMoney(match.price); });

      var compare = document.querySelector('[data-compare]');
      if (compare) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compare.style.display = '';
          compare.textContent = formatMoney(match.compare_at_price);
        } else {
          compare.style.display = 'none';
        }
      }

      var atc = document.querySelector('[data-atc-button]');
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.getAttribute('data-label') || atc.textContent : 'Out of Stock';
      }

      var stock = document.querySelector('.pdp-stock');
      if (stock) stock.classList.toggle('is-out', !match.available);

      if (match.featured_image && match.featured_image.src) {
        var mainImg = document.querySelector('[data-gallery-main]');
        if (mainImg) mainImg.src = match.featured_image.src;
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    };

    groups.forEach(function (group, gi) {
      group.querySelectorAll('.pdp-variant').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.pdp-variant').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          selected[gi] = btn.getAttribute('data-option-value');
          var label = document.querySelector('[data-option-selected="' + gi + '"]');
          if (label) label.textContent = selected[gi];
          apply();
        });
      });
    });

    var atcBtn = document.querySelector('[data-atc-button]');
    if (atcBtn) atcBtn.setAttribute('data-label', atcBtn.textContent.trim());
  }

  /* Sticky add-to-cart */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var atcAnchor = document.querySelector('[data-atc-anchor]');
  if (stickyAtc && atcAnchor && 'IntersectionObserver' in window) {
    var atcIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    atcIo.observe(atcAnchor);
  }
});
